/* 布局 */
//前台
import Layout from "@views/layout";

const propertywarehouseRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "propertywarehouse/list",
        name: "PROPERTYWAREHOUSE",
        meta: {
            title: "资产仓库管理",
            keepAlive:true
        },
        component: () => import("@views/business/propertywarehouse/index.vue"),
    },
        ],
};

export default propertywarehouseRouter;
